import axiosInstance from '../../config';

// logout function for logout service

// async funtion for make smoother and faster without waiting of acknowledgement

export const mailVerificationService = async (email) => {
  try {
    const response = await axiosInstance.post('/v1/resend-mail-verification', { email });
    

    return {
      success: true,
      data: response.data, //return data
      status: response.status //return status
    };
  } catch (error) {
   
 return {
      success: false,
      message: error.response?.data?.message || "Verification failed",
      status: error.response?.status || 500,
      errors: error.response?.data?.errors || null,
    };
  }
};
